<template>
    <button class="post__reaction--item" :class="{'post__reaction--item-liked': userLike}" @click="reactPost">
        <img :src="`${$store.state.apiUrl}/images/reactions/svg/${reactionData.svg}.svg`" :alt="`reaction image ${reactionData.name}`" class="post__reaction--img">
        {{t(`reactions.${reactionData.name}`)}}
        <span v-if="reactionData.likes.length">{{reactionData.likes.length}}</span>
    </button>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import axios from 'axios';


import en from "@/locales/en/post/post.json";
import fr from "@/locales/fr/post/post.json";

export default {
    props:['reaction', 'idPost'],
    setup(props){
        const store = useStore();
        const userLike = ref(props.reaction.likes.includes(store.state.user._id));
        const reactionData = ref(props.reaction);

        const {t, locale}  = useI18n({
			messages:{
              en: en,
              fr: fr
            }
		})


        const reactPost = async () => {
            if(!store.state.loggedIn){
                store.commit('showLoginPopup')
            }else{
                const reactionName = props.reaction.name;
                try{

                    let method = 'POST';
                    if(userLike.value){
                        method = 'DELETE';
                    }
                    const res = await axios({
                        method,
                        url: `posts/reaction/${reactionName}/${props.idPost}`
                    })
                    
                    
                    if(res.status == '201') {
                        reactionData.value.likes.push(store.state.user._id); 
                        userLike.value = true;
                    }

                    if(res.status == '204'){
                        reactionData.value.likes = reactionData.value.likes.filter(el => el != store.state.user._id); 
                        userLike.value = false;
                    }
                    
                }catch(err){
                    console.log(err);
                    console.log(err.response);
                }
            }
        }

        return {reactionData, reactPost, t, userLike}
    }
}
</script>

<style lang="scss">
@import '@/style/main';

.post{
    &__reaction{
          &--item{
            background-color: transparent;
            border: none;
            margin: 0;
            padding: 1rem .4rem;
            outline: none;
            font: inherit;

            cursor: pointer;

            display: flex;
            flex-direction: column;
            align-items: center;

            text-transform: uppercase;
            font-size: 1.2rem;
            color:inherit;
            &:not(:last-child){
                margin-right: 1.2rem;
            }
            border-radius: 10px;

            &-liked{
                background-image:linear-gradient(to bottom right, $color-blue, $color-blue-light);
                color:$color-white;
                box-shadow: $shadow;
            }

            &:hover{
                background-image:linear-gradient(to bottom right, $color-blue, $color-blue-light);
                color:$color-white;
                box-shadow: $shadow;
            }
        }

        

        & span{
            &:not(:empty){
                background-image:linear-gradient(to bottom right, $color-orange-dark, $color-orange-light);
                padding: 0 1.4rem;
                border-radius:100rem;
                color:$color-white;
                font-size: 1.2rem;
                margin-top: .6rem;
            }
            
        }



        &--img{
            width: 5.5rem;
            height: 5.5rem;

            transition:  all .2s;
        }

        &--item:hover > &--img{
            transform: scale(1.15);
        }
    }
}

</style>